module.exports = __webpack_public_path__ + "img/emoji_28.c67f0143.png";